var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.670654,
    width: 32,
    height: 32,
    rx: 4.82077,
    fill: "#0891B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9828 13.4568H20.0174M11.9828 16.6706H15.1966M16.0001 23.0983L12.7862 19.8845H10.3758C9.48836 19.8845 8.76892 19.165 8.76892 18.2776V11.8499C8.76892 10.9624 9.48836 10.243 10.3758 10.243H21.6243C22.5118 10.243 23.2312 10.9624 23.2312 11.8499V18.2776C23.2312 19.165 22.5118 19.8845 21.6243 19.8845H19.2139L16.0001 23.0983Z",
    stroke: "white",
    strokeWidth: 1.60692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon0);
export default __webpack_public_path__ + "static/media/icon.0.fc7503da82baa39cf1e6e96cbfdab3d8.svg";
export { ForwardRef as ReactComponent };